<header class="main-header">
  <div class="header-left">
    <div class="school-selector">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-select [value]="selectedEstablishmentId" class="header-select" panelClass="custom-header-select-panel"
          (selectionChange)="onSchoolChange($event)">
          <mat-select-trigger>
            @if (selectedEstablishment) {
            <span class="fase-prefix">#{{ selectedEstablishment.establishmentFase }}</span> {{
            selectedEstablishment.establishmentName }}
            }
          </mat-select-trigger>
          @for (establishment of establishments; track $index) {
          <mat-option [value]="establishment.id">
            <span class="fase-prefix">#{{ establishment.establishmentFase }}</span> {{ establishment.establishmentName
            }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="year-selector">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-select [value]="currentSchoolYear" class="header-select" panelClass="custom-header-select-panel"
          (selectionChange)="onSchoolYearChange($event)">
          @for (schoolYear of [2024, 2025, 2026]; track $index) {
          <mat-option [value]="schoolYear">
            <span class="fase-prefix">{{ schoolYear | schoolYearFormat}}</span>
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="header-right">
    <button class="user-menu-trigger" [matMenuTriggerFor]="userMenu" data-cy="user-menu-button">
      <div class="user-avatar">
        <mat-icon>person</mat-icon>
      </div>
      <div class="user-info">
        <span class="user-name">{{userName}} <mat-icon class="chevron">expand_more</mat-icon></span>
      </div>
    </button>
    <mat-menu #userMenu="matMenu" xPosition="before">
      <button mat-menu-item (click)="onLogout()" data-cy="logout-button">
        <mat-icon>exit_to_app</mat-icon>
        <span>Se déconnecter</span>
      </button>
    </mat-menu>
  </div>
</header>